import i18n from 'i18next';

i18n
  .init({
    resources: {
      de: {
        translations: {
          "AppBar.LinkCampaigns": "Kampagnen",
          "AppBar.LinkStatistics": "Statistik",
          "AppBar.LinkSettings": "Mein Account",
          "AppBar.LinkLogout": "Ausloggen",

          "Login.InfoHeadline": "Affiliatesystem",
          "Login.InfoText": "Herzlich willkommen beim page4 Partnerprogramm",
          'Login.Email': "Email",
          "Login.Password": "Passwort",
          "Login.Button": "Einloggen",
          "Login.ForgotPassword": "Passwort vergessen?",
          "Login.FormHeadline": "Einloggen",
          "Login.EmailInvalid": "Bitte gebe eine gültige Emailadresse ein",
          "Login.PasswordInvalid": "Email und/oder Passwort ist nicht korrekt",

          "ForgotPwd.InfoHeadline": "Affiliatesystem",
          "ForgotPwd.InfoText": "Bitte gebe deine Emailadresse an",
          "ForgotPwd.FormHeadline": "Passwort zurücksetzen",
          "ForgotPwd.Email": "Email",
          "ForgotPwd.BackToLogin": "Zurück zum Login",
          "ForgotPwd.Button": "Anfrage absenden",

          "ForgotPwd.EmailInvalid": "Bitte gebe eine gültige Emailadresse ein",
          "ForgotPwd.MessageSent": "Wir haben Dir Informationen zum Zurücksetzen an Dein Postfach geschickt.",
          "ForgotPwd.RequestError": "Leider konnten wir dein Passwort nicht zurücksetzen. Hast du die korrekte Emailadresse angegeben?",

          "ResetPassword.InfoHeadline": "Affiliatesystem",
          "ResetPassword.InfoText": "Dein neues Passwort muss mindestens 8 Zeichen lang sein und folgenden Inhalt haben: \n\nEin oder mehrere Großbuchstaben, ein oder mehrere Kleinbuchstaben und mind. eine Zahl.",
          "ResetPassword.FormHeadline": "Neues Passwort setzen",
          "ResetPassword.Password": "Neues Passwort",
          "ResetPassword.PasswordRepeat": "Wiederholung Passwort",
          "ResetPassword.Button": "Passwort ändern",
          "ResetPassword.PasswordError": "Dein Passwort entspricht leider nicht den Anforderungen",
          "ResetPassword.PasswordRepeatError": "Bitte wiederhole dein Passwort",
          "ResetPassword.Success": "Dein Passwort wurde erfolgreich geändert",
          "ResetPassword.Error": "Der Wiederherstellungscode ist entweder bereits abgelaufen oder ungültig",

          "CampaignOverview.Headline": "Meine Kampagnen",
          "CampaignOverview.InfoText": "Übersicht meiner Kampagnen",
          "CampaignOverview.CreateDefault": "Neue Kampagne",
          "CampaignOverview.RenameButton": "Umbenennen",
          "CampaignOverview.RenamePrompt": "Kampagne umbenennen",
          "CampaignOverview.RenameSuccess": "Kampagne erfolgreich umbenannt",
          "CampaignOverview.DetailsButton": "Details",
          "CampaignOverview.RemoveButton": "Löschen",
          "CampaignOverview.RemoveConfirm": "Bitte bestätige das Löschen der Kampagne",
          "CampaignOverview.RemoveSuccess": "Kampagne wurde gelöscht",
          "CampaignOverview.AddCampaign": "Kampagne anlegen",
          "CampaignOverview.CreateSuccess": "Kampagne erfolgreich angelegt",


          "PersonalDataBox.Headline": "Daten zu deiner Person",
          "PersonalDataBox.InfoText": "Falls du deine Emailadresse ändern möchtest, kontaktiere bitte unseren Support",
          "PersonalDataBox.Email": "Email",
          "PersonalDataBox.Organisation": "Organisation",
          "PersonalDataBox.FirstName": "Vorname",
          "PersonalDataBox.LastName": "Nachname",
          "PersonalDataBox.Street": "Straße",
          "PersonalDataBox.PostCode": "PLZ",
          "PersonalDataBox.City": "Stadt",
          "PersonalDataBox.Country": "Land",
          "PersonalDataBox.Submit": "Speichern",
          "PersonalDataBox.SaveSuccess": "Deine persönlichen Daten wurden geändert",
          "PersonalDataBox.SaveError": "Deine persönlichen Daten konnten leider nicht geändert werden",

          "PasswordBox.Headline": "Passwort ändern",
          "PasswordBox.InfoText": "Dein neues Passwort muss mindestens 8 Zeichen lang sein und folgenden Inhalt haben: \nEin oder mehrere Großbuchstaben, ein oder mehrere Kleinbuchstaben und mind. eine Zahl.",
          "PasswordBox.OldPassword": "Dein aktuelles Passwort",
          "PasswordBox.NewPassword": "Dein neues Passwort",
          "PasswordBox.NewPasswordRepeat": "Passwort Wiederholung",
          "PasswordBox.Submit": "Passwort ändern",
          "PasswordBox.SaveSuccess": "Dein Passwort wurde erfolgreich geändert",
          "PasswordBox.SaveError": "Dein Passwort wurde NICHT geändert. Bitte prüfe deine Eingaben und versuche es erneut.",
          "PasswordBox.OldPasswordError": "Dein Passwort ist nicht korrekt",
          "PasswordBox.NewPasswordError": "Das neue Passwort entspricht leider nicht den Anforderungen",
          "PasswordBox.RepeatError": "Bitte wiederhole dein Passwort",

          "CampaignDetailsBox.Headline": "Kampagnen Einstellungen",
          "CampaignDetailsBox.InfoText": "Hier kannst du den Namen und das Ziel deine Kampagne angeben",
          "CampaignDetailsBox.DisplayName": "Name",
          "CampaignDetailsBox.Target": "Ziel",
          "CampaignDetailsBox.Submit": "Speichern",
          "CampaignDetailsBox.SaveSuccess": "Kampagnen aktualisiert",
          "CampaignDetailsBox.SaveError": "Die Kampagne konnte leider nicht aktualisiert werden",
          "CampaignDetailsBox.ShowTarget": "Ziel in neuem Tab öffnen",

          "CampaignLinkBox.Headline": "Dein Affiliatelink für diese Kampagne",
          "CampaignLinkBox.InfoText": "Gebe diesen Link weiter oder nutze eine unserer HTML-Vorlagen. Ein Klick auf den Link kopiert diesen in die Zwischenablage.",

          "CampaignAdsBox.Headline": "Vorlagen",
          "CampaignAdsBox.InfoText": "Vorlagen zum Verlinken deiner Affiliatekampagne",
          "CampaignAdsBox.ElementHeadline": "Vorlage",
          "CampaignAdsBox.Preview": "Vorschau",
          "CampaignAdsBox.Source": "Quellcode zum Kopieren",
          "CampaignAdsBox.CopySuccess": "Quellcode wurde in die Zwischenablage kopiert",
          "CampaignAdsBox.PreviewSmall": "Klein",
          "CampaignAdsBox.PreviewMedium": "Mittel",
          "CampaignAdsBox.PreviewLarge": "Groß",
          "CampaignAdsBox.PreviewHuge": "Sehr Groß",

          "CampaignAdsBox.Headline.text": "Vorlagen: Text",
          "CampaignAdsBox.InfoText.text": "Vorlagen zum Verlinken deiner Affiliatekampagne, Klicke auf eine Vorlage um den Quellcode zu kopieren",
          "CampaignAdsBox.Headline.square": "Vorlagen: Bild(quadratisch)",
          "CampaignAdsBox.InfoText.square": "Vorlagen zum Verlinken deiner Affiliatekampagne, Klicke auf eine Vorlage um den Quellcode zu kopieren",
          "CampaignAdsBox.Headline.landscape": "Vorlagen: Bild(breit)",
          "CampaignAdsBox.InfoText.landscape": "Vorlagen zum Verlinken deiner Affiliatekampagne, Klicke auf eine Vorlage um den Quellcode zu kopieren",
          "CampaignAdsBox.Headline.portrait": "Vorlagen: Bild(hoch)",
          "CampaignAdsBox.InfoText.portrait": "Vorlagen zum Verlinken deiner Affiliatekampagne, Klicke auf eine Vorlage um den Quellcode zu kopieren",

          "ClicksBox.Headline" : "Klicks",
          "ClicksBox.InfoText" : "Übersicht der Klicks auf deine Affiliatelinks",
          "ClicksBox.Column_1_1" : "Kampagne",
          "ClicksBox.Column_1_2" : "Gesamt",
          "ClicksBox.Column_1_3" : "1 Tag",
          "ClicksBox.Column_1_4" : "7 Tage",
          "ClicksBox.Column_1_5" : "30 Tage",
          "ClicksBox.Column_1_6" : "90 Tage",
          "ClicksBox.Column_1_7" : "1 Jahr",
          "ClicksBox.Column_2_1" : "Datum",
          "ClicksBox.Column_2_2" : "Kampagne",
          "ClicksBox.Column_2_3" : "Ländercode",

          "CommissionsBox.Headline" : "Provision",
          "CommissionsBox.InfoText" : "Übersicht aller Provisionen",
          "CommissionsBox.Status.cancelled" : "Storniert",
          "CommissionsBox.Status.pending" : "Steht noch aus",
          "CommissionsBox.Status.confirmed" : "Bestätigt",
          "CommissionsBox.Column_1_1" : "Kampagne",
          "CommissionsBox.Column_1_2" : "Einnahmen (Summe)",
          "CommissionsBox.Column_1_3" : "Provisionen (Anzahl)",
          "CommissionsBox.Column_1_4" : "Benutzer",
          "CommissionsBox.Column_1_5" : "Clicks",
          "CommissionsBox.Column_1_6" : "",
          "CommissionsBox.Column_1_7" : "",
          "CommissionsBox.Column_2_1" : "Datum",
          "CommissionsBox.Column_2_2" : "Kampagne",
          "CommissionsBox.Column_2_3" : "Summe",
          "CommissionsBox.Column_2_4" : "Status",

          "PaymentBox.Headline": "Provisionen",
          "PaymentBox.InfoText": "Provisionsauszahlungen sind ab 50€ möglich",
          "PaymentBox.Balance": "Kontostand",
          "PaymentBox.RequestPayment": "Auszahlung anfordern",
          "PaymentBox.Method": "Auszahlungsmethode",
          "PaymentBox.MethodInfo.none": "Keine",
          "PaymentBox.MethodInfo.paypal": "Paypalkonto mit Emailadresse ****@",
          "PaymentBox.MethodInfo.iban": "Bankkonto endet mit ",
          "PaymentBox.EditPaymentMethod": "Ändern",
          "PaymentBox.RequestPaymentPrompt": "Möchtest du eine Auszahlung anfordern?",
          "PaymentBox.RequestSuccess": "Eine Auszahlung wurde erfolgreich angefordert",
          "PaymentBox.RequestError": "Eine Auszahlung wurde leider NICHT erfolgreich angefordert",

          "PaymentBox.MethodEditor.Headline": "Auszahlungsmethode ändern",
          "PaymentBox.MethodEditor.Info": "Wähle bitte die gewünschte Auszahlungsmethode aus",
          "PaymentBox.MethodEditor.Type": "Auszahlungsmethode",
          "PaymentBox.MethodEditor.TypeNone": "Keine Auszahlungsmethode",
          "PaymentBox.MethodEditor.TypePaypal": "Paypal",
          "PaymentBox.MethodEditor.TypeIban": "Bankkonto (IBAN)",
          "PaymentBox.MethodEditor.Paypal": "Paypal Adresse",
          "PaymentBox.MethodEditor.AccountOwner": "Kontoinhaber",
          "PaymentBox.MethodEditor.Iban": "Kontonummer (IBAN)",
          "PaymentBox.MethodEditor.Abort": "Abbrechen",
          "PaymentBox.MethodEditor.Submit": "Speichern",
          "PaymentBox.MethodEditor.SaveError": "Bitte überprüfe deine Angaben.",
          "PaymentBox.MethodEditor.SaveSuccess": "Deine Auszahlungsmethode wurde erfolgreich geändert."
        }
      },
      en: {
        translations: {

          "AppBar.LinkLogout": "Logout",

          "Login.InfoHeadline": "Go your own way",
          "Login.InfoText": "Please use your credentials to login.",
          'Login.Email': "Email Address",
          "Login.Password": "Password",
          "Login.Button": "Login",
          "Login.ForgotPassword": "Forgot password ?",
          "Login.FormHeadline": "Login",
          "Login.EmailInvalid": "Please enter a valid email address",
          "Login.PasswordInvalid": "Email and/or password is incorrect",

          "ForgotPwd.InfoHeadline": "Go your own way",
          "ForgotPwd.InfoText": "Please enter your email address associated with your account",
          "ForgotPwd.FormHeadline": "Request an password reset",
          "ForgotPwd.Email": "Email address",
          "ForgotPwd.BackToLogin": "Back to login",
          "ForgotPwd.Button": "Send request",

          "ForgotPwd.EmailInvalid": "Please enter a valid email address",
          "ForgotPwd.MessageSent": "Please check your mailbox for a message with instructions on how to reset your password",
          "ForgotPwd.RequestError": "We weren't able to reset your password, did you enter the correct email?",

          "ResetPassword.InfoHeadline": "Go your own way",
          "ResetPassword.InfoText": "Your new password must be at least 8 characters long and must contain the following elements:\n\nAn uppercase character, a lowercase character and a number.",
          "ResetPassword.FormHeadline": "Reset your password",
          "ResetPassword.NewPassword": "New password",
          "ResetPassword.NewPasswordRepeat": "Repeat the new password",
          "ResetPassword.Button": "Update password",
          "ResetPassword.PasswordError": "Your password doesn't meet our security requirements",
          "ResetPassword.RepeatError": "Please repeat your new password",
          "ResetPassword.Success": "Your password has been successfully updated",
          "ResetPassword.Error": "The provided recovery key was either invalid, already used or expired",

          "PersonalDataBox.Headline": "Your personal data",
          "PersonalDataBox.InfoText": "To change your email address please contact our support",
          "PersonalDataBox.Email": "Email",
          "PersonalDataBox.Organisation": "Organisation",
          "PersonalDataBox.FirstName": "First name",
          "PersonalDataBox.LastName": "Last name",
          "PersonalDataBox.Street": "Street",
          "PersonalDataBox.PostCode": "Postcode",
          "PersonalDataBox.City": "City",
          "PersonalDataBox.Country": "Country",
          "PersonalDataBox.Submit": "Save",
          "PersonalDataBox.SaveSuccess": "Your personal data has been updated",
          "PersonalDataBox.SaveError": "Your personal data could not been updated",

          "PasswordBox.Headline": "Change password",
          "PasswordBox.InfoText": "Your new password must be at least 8 characters long and must contain the following elements:\n\nAn uppercase character, a lowercase character and a number.",
          "PasswordBox.OldPassword": "Your current password",
          "PasswordBox.NewPassword": "The new password",
          "PasswordBox.NewPasswordRepeat": "Repeat the new password",
          "PasswordBox.Submit": "Change password",
          "PasswordBox.SaveSuccess": "Your password has been successfully updated",
          "PasswordBox.SaveError": "Your password was NOT updated. Please check and try again.",
          "PasswordBox.OldPasswordError": "Your password is not correct",
          "PasswordBox.NewPasswordError": "Your password does not meet the requirements",
          "PasswordBox.RepeatError": "Please repeat your new password",
        }
      }
    },
    fallbackLng: 'de',
    debug: false,

    ns: ['translations'],
    defaultNS: 'translations',

    keySeparator: false,

    interpolation: {
      escapeValue: false,
      formatSeparator: ','
    },

    // react: {
    //   wait: true
    // }
  }).then(() => {});

export default i18n;